/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Component, OnInit, ViewChild } from '@angular/core';
import { AccessPointService } from '../_service/access-point.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderButtonComponent } from '../_common/loader-button/loader-button.component';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
   selector: 'app-access-point',
   templateUrl: './access-point.component.html',
   styleUrls: ['./access-point.component.css']
})
export class AccessPointComponent implements OnInit {

   @ViewChild(LoaderButtonComponent) sendButton: LoaderButtonComponent;

   public response: any;
   public guidedResponse: any;

   // guided mode form
   apForm: FormGroup;
   formBuilder: FormBuilder;
   payload: string;

   // retieve messages
   pendingMessagesList = [];
   selectedMessageId: string;
   messageRetrieved: string;

   formSubmitted = false;
   constructor(private apService: AccessPointService) { }

   ngOnInit(): void {
      this.apForm = new FormGroup({
         ootsRequestId: new FormControl('OOTS-TEST-123', Validators.required),
         evidenceRequirementId: new FormControl('evidenceRequirementId', Validators.required),
         evidenceRequesterId: new FormControl('oots_ap_es', Validators.required),
         evidenceProviderId: new FormControl('harmony-org1', Validators.required),
         evidenceClassificationId: new FormControl('classificationId'),
         countryCode: new FormControl('ES', Validators.required),
         payload: new FormControl(this.samplePayload, Validators.required)
      });
   }

   retrieveMessage() {
      console.log("Retrieve message id: " + this.selectedMessageId);
      this.apService.retrieveMessageById(this.selectedMessageId).subscribe(
         {
            next: result => {
               this.messageRetrieved = result;
               console.info(result);
            },
            error: (e) => {
               console.error(e);
            },
            complete: () => this.sendButton.requestFinished()
         });
   }

   retrievePendingMessages() {
      this.apService.retrievePendingMessages().subscribe(
         {
            next: result => {
               this.pendingMessagesList = result;
               console.info(result);
            },
            error: (e) => {
               console.error(e)
            },
            complete: () => console.info('complete')
         });
   }

   onTabChange(event: MatTabChangeEvent) {
      if (event.index == 2) {
         // retieve list of pending messages
         this.retrievePendingMessages();
      }
   }

   onSubmit() {
      this.apService.sendPlainXML(this.xmlContent).subscribe(
         {
            next: result => {
               this.response = result;
               console.info(result);
               this.sendButton.requestFinished();
            },
            error: (e) => {
               console.error(e)
               this.sendButton.requestFinished();
            },
            complete: () => console.info('complete')
         });
   }

   onGuidedSubmit() {
      this.formSubmitted = true;
      this.apService.sendGuidedModeRequest(this.apForm.value).subscribe(
         {
            next: result => {
               this.guidedResponse = result;
               console.info(result);
               this.sendButton.requestFinished();
            },
            error: (e) => {
               console.error(e);
               this.sendButton.requestFinished();
            },
            complete: () => console.info('complete')
         });
   }

   formatXml(xml: string): string {
      const xmlDoc = new DOMParser().parseFromString(xml, 'application/xml');
      const serializer = new XMLSerializer();
      return serializer.serializeToString(xmlDoc);
   }

   xmlContent = `<soap:Envelope xmlns:_1="http://org.ecodex.backend/1_1/" xmlns:ns="http://docs.oasis-open.org/ebxml-msg/ebms/v3.0/ns/core/200704/" xmlns:soap="http://www.w3.org/2003/05/soap-envelope" xmlns:xm="http://www.w3.org/2005/05/xmlmime">
  <soap:Header>
     <ns:Messaging>
        <ns:UserMessage>
           <ns:PartyInfo>
              <ns:From>
                 <ns:PartyId type="urn:oasis:names:tc:ebcore:partyid-type:unregistered:oots-simulator">oots_ap_es</ns:PartyId>
                 <ns:Role>http://sdg.europa.eu/edelivery/gateway</ns:Role>
              </ns:From>
              <ns:To>
                 <ns:PartyId type="urn:oasis:names:tc:ebcore:partyid-type:unregistered:oots-simulator">harmony-org1</ns:PartyId>
                 <ns:Role>http://sdg.europa.eu/edelivery/gateway</ns:Role>
              </ns:To>
           </ns:PartyInfo>
           <ns:CollaborationInfo>
              <ns:Service type="urn:oasis:names:tc:ebcore:ebrs:ebms:binding:1.0">QueryManager</ns:Service>
              <ns:Action>ExecuteQueryRequest</ns:Action>
              <ns:ConversationId>aaad4c39-f073-4547-acd7-35be6438f8ca</ns:ConversationId>
           </ns:CollaborationInfo>
           <ns:MessageProperties>
            <ns:Property name="originalSender">C1</ns:Property>
            <ns:Property name="finalRecipient">FIDVV002</ns:Property>
       </ns:MessageProperties>
           <ns:PayloadInfo>
              <ns:PartInfo href="cid:regrep@oots.eu">
                 <ns:PartProperties>
                    <ns:Property name="MimeType">application/x-ebrs+xml</ns:Property>
                    <ns:Property name="PayloadName">request.xml</ns:Property>
                 </ns:PartProperties>
              </ns:PartInfo>
           </ns:PayloadInfo>
        </ns:UserMessage>
     </ns:Messaging>
  </soap:Header>
  <soap:Body>
     <_1:submitRequest>
        <payload contentType="application/x-ebrs+xml" payloadId="cid:regrep@oots.eu">
           <value>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</value>
        </payload>
     </_1:submitRequest>
  </soap:Body>
</soap:Envelope>`;

   samplePayload = `<?xml version="1.0" encoding="UTF-8"?>
<query:QueryRequest xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
					xmlns:rs="urn:oasis:names:tc:ebxml-regrep:xsd:rs:4.0" xmlns:sdg="http://data.europa.eu/p4s"
					xmlns:xmime="http://www.w3.org/2005/05/xmlmime"
					xmlns:rim="urn:oasis:names:tc:ebxml-regrep:xsd:rim:4.0"
					xmlns:query="urn:oasis:names:tc:ebxml-regrep:xsd:query:4.0"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					xml:lang="DE"
					id="urn:uuid:4ffb5281-179d-4578-adf2-39fd13ccc797">
	
	<rim:Slot name="SpecificationIdentifier">
		<rim:SlotValue xsi:type="rim:StringValueType">
			<rim:Value>oots-edm:v1.0</rim:Value>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="IssueDateTime">
		<rim:SlotValue xsi:type="rim:DateTimeValueType">
			<rim:Value>2023-03-30T10:20:30+01:00</rim:Value>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="Procedure">
		<rim:SlotValue xsi:type="rim:InternationalStringValueType">
			<rim:Value>
				<rim:LocalizedString xml:lang="EN" value="T2"/>
			</rim:Value>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="PossibilityForPreview">
		<rim:SlotValue xsi:type="rim:BooleanValueType">
			<!-- XXX This one needs to be switched to false for the non-preview cases -->
			<rim:Value>false</rim:Value>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="ExplicitRequestGiven">
		<rim:SlotValue xsi:type="rim:BooleanValueType">
			<rim:Value>true</rim:Value>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="Requirements">
		<rim:SlotValue xsi:type="rim:CollectionValueType"
			collectionType="urn:oasis:names:tc:ebxml-regrep:CollectionType:Set">
			<rim:Element xsi:type="rim:AnyValueType">
				<sdg:Requirement>
					<sdg:Identifier>https://sr.oots.tech.europa.eu/requirements/f8a6a284-34e9-42c7-9733-63b5c4f4aa42</sdg:Identifier>
					<sdg:Name lang="EN">Proof of tertiary education diploma/certificate/degree</sdg:Name>
				</sdg:Requirement>
			</rim:Element>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="EvidenceRequester">
		<!-- YYY if desired, Evidence Requesters can update this data -->
		<rim:SlotValue xsi:type="rim:CollectionValueType">
			<rim:Element xsi:type="rim:AnyValueType">
				<sdg:Agent>
					<sdg:Identifier schemeID="urn:cef.eu:names:identifier:EAS:0190">NL222332239</sdg:Identifier>
					<sdg:Name lang="EN">University of Amsterdam</sdg:Name>
					<sdg:Address>
						<sdg:FullAddress>Binnengasthuisstraat 9</sdg:FullAddress>
						<sdg:LocatorDesignator>9</sdg:LocatorDesignator>
						<sdg:PostCode>1012</sdg:PostCode>
						<sdg:PostCityName>Amsterdam</sdg:PostCityName>
						<sdg:AdminUnitLevel1>NL</sdg:AdminUnitLevel1>
						<sdg:AdminUnitLevel2>NL329</sdg:AdminUnitLevel2>
					</sdg:Address>
					<sdg:Classification>ER</sdg:Classification>
				</sdg:Agent>
			</rim:Element>
		</rim:SlotValue>
	</rim:Slot>
	<rim:Slot name="EvidenceProvider">
		<!-- ZZZ preferably, Evidence Requesters can update this data to match with the actual Evidence Provider they are sending the request to -->
		<rim:SlotValue xsi:type="rim:AnyValueType">
			<sdg:Agent>
				<sdg:Identifier schemeID="urn:cef.eu:names:identifier:EAS:0204">02-SchoolAuthority-34</sdg:Identifier>
				<sdg:Name lang="EN">Authority for school and occupational training</sdg:Name>
			</sdg:Agent>
		</rim:SlotValue>
	</rim:Slot>
	<query:ResponseOption returnType="LeafClassWithRepositoryItem"/>
	<query:Query queryDefinition="DocumentQuery">
		<rim:Slot name="NaturalPerson">
			<rim:SlotValue xsi:type="rim:AnyValueType">
				<sdg:Person>
					<!-- This is the person for which an evidence must be available at EP side -->
					<!-- Variations to the GivenName will be used to cover different Test Cases -->
					<sdg:LevelOfAssurance>High</sdg:LevelOfAssurance>
					<!-- Identifier has been removed for the June Projectathon as the element is optional in the OOTS flows according to the TDDs -->
					<!-- <sdg:Identifier schemeID="eidas">DE/DE/123456789</sdg:Identifier> -->
					<sdg:FamilyName>Smith</sdg:FamilyName>
					<sdg:GivenName>Jack</sdg:GivenName>
					<sdg:DateOfBirth>1999-03-01</sdg:DateOfBirth>
					<sdg:PlaceOfBirth>Duesseldorf</sdg:PlaceOfBirth>
					<sdg:CurrentAddress>
						<sdg:FullAddress>Lansstrasse 81, 50825 Koeln, Germany</sdg:FullAddress>
						<sdg:LocatorDesignator>81</sdg:LocatorDesignator>
						<sdg:PostCode>50825</sdg:PostCode>
						<sdg:PostCityName>Koeln</sdg:PostCityName>
						<sdg:Thoroughfare>Lansstrasse</sdg:Thoroughfare>
						<sdg:AdminUnitLevel1>DE</sdg:AdminUnitLevel1>
						<sdg:AdminUnitLevel2>DEA2</sdg:AdminUnitLevel2>
					</sdg:CurrentAddress>
					<sdg:Gender>Male</sdg:Gender>
				</sdg:Person>
			</rim:SlotValue>
		</rim:Slot>
		<rim:Slot name="EvidenceRequest">
			<rim:SlotValue xsi:type="rim:AnyValueType">
				<sdg:DataServiceEvidenceType>
					<sdg:Identifier>59f098d4-8afe-4ac2-9197-b8fe9e1c2c85</sdg:Identifier>
					<sdg:EvidenceTypeClassification>https://sr.oots.tech.europa.eu/evidencetypeclassifications/EU/b6a49e54-8b3c-4688-acad-380440dc5962</sdg:EvidenceTypeClassification>
					<sdg:Title lang="EN">EU-Wide Diploma/Bachelor's Degree</sdg:Title>
					<sdg:Description lang="EN">The description that the OOTS team specified as static data for this Projectathon related to the EU-Wide evidence</sdg:Description>
					<sdg:DistributedAs>
						<sdg:Format>application/pdf</sdg:Format>
					</sdg:DistributedAs>
				</sdg:DataServiceEvidenceType>
			</rim:SlotValue>
		</rim:Slot>
	</query:Query>
</query:QueryRequest>`;

}
